import {
  Box,
  Button,
  Dialog,
  DialogContent,
  ToggleButtons,
  Typography,
} from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    position: 'relative',
    background: 'transparent',
    boxShadow: '0 144px 250px 0 rgba(221, 253, 108, 0.20)',
    borderRadius: theme.spacing(10),
    padding: theme.spacing(0.5),
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: theme.customShape?.borderRadius5XL || theme.spacing(3),
      padding: theme.spacing(0.5),
      backgroundImage: `radial-gradient(transparent, transparent, #FE4B4B, #AAB2FF, #FFF, #8458FC, transparent, transparent)`,
      backgroundSize: '300% 300%',
      WebkitMask:
        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
      willChange: 'background-position',
      animation: 'shining-border 14s linear infinite',
      zIndex: 0,
    },
    '@keyframes shining-border': {
      '0%': {
        backgroundPosition: '0% 0%',
      },
      '50%': {
        backgroundPosition: '100% 100%',
      },
      '100%': {
        backgroundPosition: '0% 0%',
      },
    },
    [theme.breakpoints.up('sm')]: {
      padding: '2px',
    },
  },
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  padding: `${theme.spacing(8)} ${theme.spacing(6)}`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  borderRadius: theme.spacing(10),
  background:
    theme.palette.mode === 'dark'
      ? `radial-gradient(60.07% 53.71% at 0% -2.44%, rgba(132, 88, 252, 0.60) 0%, rgba(132, 88, 252, 0.00) 100%), #000`
      : `radial-gradient(60.07% 53.71% at 0% -2.44%, rgba(221, 253, 108, 0.60) 0%, rgba(221, 253, 108, 0.00) 100%), #FFF`,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(12),
  },
}));

export const StyledIllustrationPlaceholder = styled(Box)(({ theme }) => ({
  height: theme.spacing(8),
  marginBottom: theme.spacing(2),
}));

export const StyledIllustration = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  '& svg': {
    width: '100%',
    height: 'auto',
    maxWidth: theme.spacing(56),
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.text.primary,
  fontWeight: 700,
  marginBottom: theme.spacing(1),
}));

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
}));

export const StyledToggleButton = styled(ToggleButtons)(({ theme }) => ({
  border: `1px solid ${theme.palette.text.fourth} !important`,
  color: `${theme.palette.text.secondary} !important`,
  '&.Mui-selected': {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${
      theme.palette.mode === 'dark'
        ? theme.palette.text.black
        : theme.palette.text.opposite
    } !important`,
    '& *': {
      color: `${
        theme.palette.mode === 'dark'
          ? theme.palette.text.black
          : theme.palette.text.opposite
      } !important`,
    },
  },
}));

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 3),
  '&:not(.Mui-disabled)': {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  '&:not(.Mui-disabled):hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover,
  },
}));
